import { createQueryKeys } from '@lukemorales/query-key-factory'

export const settings = createQueryKeys('settings', {
	favicon: null,
	logo: null,
	storePic: null,
	publicSettings: null,
	settings: null,
})
